import React from 'react';
import * as PropTypes from 'prop-types';
import ReactCropper from 'react-cropper';
import Slider from 'rc-slider';
import Modal from './Modal';

// import Modal from '../Modal';

// Utils
import { getFileInfo } from './utils';

/** CropperModel functional component */
function CropperModel(props) {
  const { labels, file } = props;
  const [cropper, setCropper] = React.useState(null);
  const [image, setImage] = React.useState(null);
  const [zoom, setZoom] = React.useState(props.initialZoom);
  const [rotate, setRotate] = React.useState(props.initialRotate);

  React.useEffect(() => {
    if (file !== null) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImage(reader.result);
        // cropper && cropper
        //   .zoomTo(props.initialZoom)
        //   .rotateTo(props.initialRotate);
      });
      reader.readAsDataURL(file);
    } else {
      setImage(null);
      setCropper(null);
    }
  }, [props, file, cropper]);

  const onConfirm = () => {
    if (!cropper) {
      return;
    }

    const croppedCanvas = {
      minWidth: 200, maxWidth: 600,
      minHeight: 200, maxHeight: 600,
      imageSmoothingQuality: 'medium',
      ...props.croppedCanvasProps,
    };

    const canvasData = cropper.getCroppedCanvas(croppedCanvas);

    const fileInfo = getFileInfo(file, props.mime);

    canvasData.toBlob((blob) => {
      const croppedFile = new File([blob], fileInfo.filename, { type: blob.type, lastModified: new Date() });
      typeof props.onConfirm === 'function' && props.onConfirm(croppedFile);
      typeof props.onCompleted === 'function' && props.onCompleted();
      setImage(null);
      setCropper(null);
    }, fileInfo.mime, props.quality);
  };

  const handleClose = () => {
    setCropper(false);
    setImage(null);
    typeof props.onDiscard === 'function' && props.onDiscard(file);
    typeof props.onCompleted === 'function' && props.onCompleted();
  };

  return (
    <Modal onClose={handleClose} show={(!!file && !!image)}>
      <div className="modal-header">
        <div className="modal-title h4 pull-left">{labels.heading}</div>
        <button type="button" className="close pull-right" onClick={handleClose}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
      </div>
      <div className="text-center modal-body">
        {image && (
          <ReactCropper
            src={image}
            style={{ height: 280, width: 280, margin: '0 auto' }}
            aspectRatio={1 / 1}
            viewMode={1}
            dragMode="move"
            cropBoxResizable={true}
            cropBoxMovable={true}
            center={true}
            toggleDragModeOnDblclick={false}
            checkOrientation={true}
            onInitialized={instance => setCropper(instance)}
            minCropBoxWidth={120}
            minCropBoxHeight={120}
            responsive={true}
            {...props.cropperProps}
          />
        )}
      </div>
      <div className="d-block modal-footer">
        <div className="row">
          <div className="col-sm-6" style={{ marginBottom: 15 }}>
            <small>{labels.zoom}</small>
            <Slider min={0} step={.1} max={4} marks={{
              '0': '0x', '1': '1x', '2': '2x', '3': '3x', '4': '4x',
            }} value={zoom} onChange={(value) => {
              setZoom(value);
              cropper.zoomTo(value);
            }} />
          </div>
          <div className="col-sm-6">
            <small>{labels.rotate}</small>
            <Slider min={-180} max={180} marks={{
              '-180': '-180°', '0': '0°', '180': '180°',
            }} value={rotate} onChange={(value) => {
              setRotate(value);
              cropper.rotateTo(value);
            }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ marginTop: 35 }}>
            <button type="button" className="mr-1 btn btn-primary" onClick={onConfirm}>{labels.confirm}</button>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>{labels.discard}</button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

CropperModel.propTypes = {
  initialZoom: PropTypes.number,
  initialRotate: PropTypes.number,
  mime: PropTypes.string,
  quality: PropTypes.number,
  file: PropTypes.object,
  labels: PropTypes.shape({
    heading: PropTypes.string,
    confirm: PropTypes.string,
    discard: PropTypes.string,
    zoom: PropTypes.string,
    rotate: PropTypes.string,
  }),
  cropperProps: PropTypes.object,
  modalProps: PropTypes.object,
  croppedCanvasProps: PropTypes.object,
  onDiscard: PropTypes.func,
  onCompleted: PropTypes.func,
}

CropperModel.defaultProps = {
  initialZoom: 0,
  initialRotate: 0,
  mime: null,
  quality: 70,
  labels: {
    heading: 'Crop Image',
    confirm: 'Confirm',
    discard: 'Discard',
    zoom: 'Zoom',
    rotate: 'Rotate',
  },
  modalProps: {},
  cropperProps: {},
  croppedCanvasProps: {},
  onDiscard: () => { },
  onCompleted: () => { },
}

export default CropperModel;
